export default __webpack_public_path__ + "2f5b566f570cc680c42c20b2460646ca.png";